import React, { startTransition } from 'react';
import { useSetAtom } from 'jotai';
import { navigateAtom } from '../../../../atoms/v3/navigationAtoms';

interface ChatHeaderTitleProps {
  title: string;
}

/**
 * 聊天标题组件
 * 包含标题文本和下拉箭头图标
 * 整体可点击，触发展开聊天列表
 * 内部直接实现点击逻辑，不需要外部传入
 */
export const ChatHeaderTitle: React.FC<ChatHeaderTitleProps> = ({ title }) => {
  const navigate = useSetAtom(navigateAtom);
  // 处理标题点击 - 展开聊天列表
  const handleClick = () => {
    // 使用路由导航到聊天列表
    startTransition(() => {
      navigate({ path: '/v3/chat-list', replace: true });
    })
  };

  return (
    <button
      onClick={handleClick}
      className="flex items-center justify-start space-x-2 py-2 w-full"
    >
      {/* 三横线图标 (F形状) */}
      <svg className="w-4 h-4 flex-shrink-0 text-ios-gray dark:text-ios-dark-gray" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 6h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M3 12h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M3 18h12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
      <h2 className="text-lg font-semibold text-ios-black dark:text-white truncate">
        {title}
      </h2>
      <svg
        className="w-5 h-5 text-ios-gray dark:text-ios-dark-gray flex-shrink-0"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 7.5L10 12.5L15 7.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};
